import "./notFound.css";

function NotFound() {
  return (
    <div id="notFoundContainer">
      <h1 id="errCodeText">404</h1>
      <p id="lostText">Are you lost?</p>
      <div id="backToHomeButton">
        <a href="https://virejdasani.github.io">Go back back to the homepage</a>
      </div>
    </div>
  );
}

export default NotFound;
